(() => {
  const STICKY_CLASS = 'ark-header-sticky';
  const SCROLL_THRESHOLD = 10;

  const headerShell = document.querySelector('.section-header .header-wrapper');
  if (!headerShell) return;

  let ticking = false;

  const updateStickyState = () => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      headerShell.classList.add(STICKY_CLASS);
    } else {
      headerShell.classList.remove(STICKY_CLASS);
    }
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    window.requestAnimationFrame(updateStickyState);
    ticking = true;
  };

  updateStickyState();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
